// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3ng8G","messages":"Chat_messages__2C9ju","dateDivider":"Chat_dateDivider__337RX"};